import { auditList } from '@/services/inqueryServices'
import _ from 'lodash'
// import { isMobile } from '@/lib/device'

// console.log(isMobile)
import i18n from '@/lib/language'

const state = {
  loading: true,
  titles: {},
  list: [],
  tableSort: {},
  sortedInfo: {},
  order: 'ascend',
  pagination: {
    currentPage: 1,
    pageSize: 10,
    pageSizes: ['10', '20', '30', '50'],
    total: 0
  }
}

const getters = {
  newList (state) {
    if (!state.list.length) return

    let data = _.cloneDeep(state.list)
    data.forEach(item => {
      for (let k in item) {
        if (item[k] === '') {
          item[k] = '- -'
        }
      }
    })
    return data
  },
  columns (state) {
    const { titles = {} } = state
    let newArr = []
    for (let fieldkey in titles) {
      const fieldTitle = titles[fieldkey].fieldname
      const fieldtype = titles[fieldkey].fieldtype
      let field = {}

      field.dataIndex = fieldkey
      field.fieldtype = fieldtype
      field.title = fieldTitle
      field.sortkey = titles[fieldkey].sortkey

      if (fieldkey === 'contact_info') {
        field.width = 126
        // field.scopedSlots = { customRender: fieldkey }
        // field.slots = { title: fieldkey }
      }
      /* if (fieldkey === 'input_time') {
        field.sorter = true
        field.defaultSortOrder = state.order
      } */
      if (field.sortkey) {
        field.sorter = true
        field.sortOrder =
          state.sortedInfo.columnKey === field.dataIndex &&
          state.sortedInfo.order

        if (state.sortedInfo.columnKey === field.dataIndex) {
          field.defaultSortOrder =
            state.tableSort.sorttype === 1 ? 'ascend' : 'descend'
        }
      }

      field.scopedSlots = { customRender: fieldkey }
      newArr.push(field)
    }
    return [
      ...newArr,
      {
        title: i18n.t('message["79"]'),
        key: 'operation',
        width: 100,
        scopedSlots: { customRender: 'action' }
      }
    ]
  },
  keyword1Placeholder (state) {
    const { titles = {} } = state
    // console.log(Object.keys(titles).includes('contact_info_company_name'))
    if (Object.keys(titles).includes('contact_info_company_name')) {
      return i18n.t('message["386"]')
    }
    return i18n.t('message["35"]')
  }
}

const mutations = {
  SET_LOADING (state, data) {
    state.loading = data
  },
  SET_LIST_DATA (state, data) {
    state.list = data
  },
  SET_TABLE_SORT (state, { tableSort = {}, sorter = {} }) {
    state.tableSort = Object.assign({}, tableSort)
    state.sortedInfo = sorter
  },
  SET_TITLES (state, data) {
    state.titles = data
  },
  SET_TOTAL (state, data) {
    state.pagination.total = data
  },
  UPDATA_ORDER (state, data) {
    state.order = data
  }
}

const actions = {
  async fetchList ({ state, commit }) {
    commit('SET_LIST_DATA', [])
    commit('SET_LOADING', true)
    const chain = await auditList().onSuccess(async payload => {
      const { data = {}, title = [] } = payload
      const { count = 0, list = [] } = data

      commit('SET_LOADING', false)
      commit('SET_LIST_DATA', list)
      commit('SET_TITLES', title)
      commit('SET_TOTAL', parseInt(count))
    })
    return chain
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
